const mutations = {
    ACCOUNT_PERFORMED_REGISTRATION(state, performedRegistration) {
      state.accountPerformedRegistration = performedRegistration;
    },
    ACCOUNT_REGISTRATION_RESPONSE(state, response) {
      state.registrationResponse = response;
    },
    MAIN_ACCOUNT_REGISTRATION_RESPONSE(state, response) {
        state.mainAccountRegistrationResponse = response;
    },
    ACCOUNT_SUBMIT_REGISTRATION(state) {
        state.showRegistrationNote = true;
    },
    SET_CATALOG_MISSING(state, value) {
      state.isMissingCatalog = value;
    },
    SET_BULK_SMS_FEATURE_FLAG(state, value) {
        state.bulkSmsFeatureEnabled = value;
    },
    ACCOUNT_NEED_RESUBMIT(state, needToResubmit) {
        state.accountNeedToResubmit = needToResubmit
    },
    REREGISTER(state, reRegister) {
        state.reRegister = reRegister
    },
    SET_SHOWN_EDIT_VIEW(state, editViewType) {
        state.shownEditView = editViewType;
    },
    TOGGLE_REQUIRED_CHANGES(state, showRequiredChanges) {
        state.showRequiredChanges = showRequiredChanges
    },
    REGISTRATION_ERROR(state, error) {
        state.registrationError = error;
    },
    CLEAR_REGISTRATION_ERROR(state) {
        state.registrationError = null;
    },
    FETCH_BULK_SMS_CAMPAIGN(state) {
        state.fetchingBulkSmsCampaign = true;
    },
    SET_BULK_SMS_CAMPAIGN(state, campaign) {
        state.bulkSmsCampaign = campaign;
        state.fetchingBulkSmsCampaign = false;
    },
    ERROR_BULK_SMS_CAMPAIGN(state) {
        state.bulkSmsCampaign = null;
        state.fetchingBulkSmsCampaign = false;
    },
    SET_BULK_SMS_CAMPAIGN_NUMBERS(state, numbers) {
        state.bulkSmsCampaignNumbers = numbers;
    },
    FETCHED_SP_FLAG(state, flagState) {
        state.soleProprietorEnabled = flagState;
    },
    FETCHED_SP_EDIT_FLAG(state, flagState) {
        state.soleProprietorEditEnabled = flagState;
    },
    SET_VOLUNTARY_EDIT_ENABLED(state, voluntaryEditEnabled) {
        state.isVoluntaryEditEnabled = voluntaryEditEnabled;
    },
    ACCOUNT_FOLLOWER_ACCOUNT(state, quickflowResponseComing) {
        state.followerAccount = quickflowResponseComing.main_account_id!=null;
        state.numberOfFollowers = quickflowResponseComing.followers ? quickflowResponseComing.followers : [];
    },
    SET_SINCH_APPROVAL_PENDING(state, value) {
        state.sinchApprovalPending = value;
    },
};

export default mutations;
